import type { MigrationStrategies } from 'rxdb';
import type { DeficiencyCommentsDocument } from './deficiencyComments.types';

export const deficiencyCommentsMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: DeficiencyCommentsDocument) => {
    return oldDoc;
  },
  2: (oldDoc: DeficiencyCommentsDocument) => {
    const newDoc = {
      ...oldDoc,
      inspectorName: oldDoc.inspectorName || null,
      componentVersionId: oldDoc.componentVersionId || null,
      componentVersionInspectionId: oldDoc.componentVersionInspectionId || null,
      isVersionComment: oldDoc.isVersionComment || null,
    };
    return newDoc;
  },
  3: (oldDoc: DeficiencyCommentsDocument) => {
    const newDoc = {
      ...oldDoc,
      inspectorName: oldDoc.clerkName || null,
    };
    return newDoc;
  },
};
